// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  backendapi: "https://app.xrack.es",
  // backendapi: "https://dev.xrack.es",
  // backendapi: `https://localhost:5001`,
  // authapi: `https://dev.xrack.thenextpangea.com/api`,
  default_phone: "+34666666666",
  baseUrlKeycloak: "https://iam.thenextpangea.com",
  realmKeycloak: "xrack",
  clientIdKeycloak: "front",
  clientSecretKeycloack: "Q5u4EIfsCrBcAl61aFC50qGN2Y2cZAmW",
};

